import { create } from 'zustand'

export interface AuthUser {
  id: string
  email: string
  name: string
  phone: string | null
  address: string | null
  isAdmin?: boolean
  createdAt?: string
}

interface AuthState {
  user: AuthUser | null
  loading: boolean
  login: (email: string, password: string) => Promise<void>
  register: (email: string, password: string, name: string, phone?: string) => Promise<void>
  logout: () => Promise<void>
  fetchMe: () => Promise<void>
  setUser: (user: AuthUser | null) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,

  login: async (email: string, password: string) => {
    set({ loading: true })
    try {
      const res = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      })
      const data = await res.json()
      if (!res.ok) {
        throw new Error(data.error || 'Ошибка входа')
      }
      set({ user: data, loading: false })
    } catch (error) {
      set({ loading: false })
      throw error
    }
  },

  register: async (email: string, password: string, name: string, phone?: string) => {
    set({ loading: true })
    try {
      const res = await fetch('/api/auth/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, name, phone }),
      })
      const data = await res.json()
      if (!res.ok) {
        throw new Error(data.error || 'Ошибка регистрации')
      }
      // Auto-login after registration
      const loginRes = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      })
      const loginData = await loginRes.json()
      if (loginRes.ok) {
        set({ user: loginData, loading: false })
      } else {
        set({ user: null, loading: false })
      }
    } catch (error) {
      set({ loading: false })
      throw error
    }
  },

  logout: async () => {
    try {
      await fetch('/api/auth/logout', { method: 'POST' })
    } catch {
      // Silently fail — still clear local state
    }
    set({ user: null })
  },

  fetchMe: async () => {
    set({ loading: true })
    try {
      const res = await fetch('/api/auth/me')
      if (!res.ok) {
        set({ user: null, loading: false })
        return
      }
      const data = await res.json()
      set({ user: data, loading: false })
    } catch {
      set({ user: null, loading: false })
    }
  },

  setUser: (user: AuthUser | null) => {
    set({ user })
  },
}))
